import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import RequestDetail from '@/components/requests/RequestDetail';
import { myRequest } from '@/lib/requests';

export default function PortalRequestDetailPage() {
  const { id = '' } = useParams<{ id: string }>();
  const [params] = useSearchParams();
  const q = useQuery({ queryKey: ['portal-request', id], queryFn: () => myRequest(id), enabled: !!id, refetchInterval: 30000 });
  return (
    <div className="space-y-4 max-w-3xl mx-auto">
      <Link to="/portal/requests" className="inline-flex items-center gap-1.5 text-[13px] text-muted hover:text-accent-400 min-h-11">
        <ArrowLeft size={14} /> All requests · <span lang="ar">كل الطلبات</span>
      </Link>
      {params.get('sent') === '1' && (
        <div className="rounded-xl border border-emerald-500/40 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-300" data-testid="sent-banner">
          Sent to KAF. You will get a reply here.
          <span className="block" dir="rtl" lang="ar">تم إرسال طلبك إلى فريق KAF، وسيصلك الرد هنا.</span>
        </div>
      )}
      {q.isLoading && <div className="text-sm text-muted py-10 text-center">Loading... / جارٍ التحميل</div>}
      {q.isError && <div className="text-sm text-muted py-10 text-center">Could not load, try again. <span lang="ar">تعذّر التحميل، حاول مرة أخرى.</span>
        <button onClick={() => q.refetch()} className="ms-2 min-h-11 px-3 text-accent-400">Retry</button></div>}
      {q.data && <RequestDetail r={q.data} portal />}
    </div>
  );
}
